import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTenant } from '../../contexts/TenantContext';
import { Button } from '../ui/button';
import { Toaster } from '../ui/sonner';
import { Inbox, LogOut } from 'lucide-react';
import { homePathForRole } from '../../lib/roles';

// Minimal shell for END USERS (business owners). No accountant sidebar, no
// "Documents"/review UI — just a clean inbox surface.
export const InboxLayout = () => {
    const { isAuthenticated, loading, isEndUser, logout, user } = useAuth();
    const { currentTenant } = useTenant();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    // Accountants / admins don't belong here — send them to their own home.
    if (!isEndUser) return <Navigate to={homePathForRole(user)} replace />;

    return (
        <div className="min-h-screen bg-background">
            <header className="border-b bg-card">
                <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
                    <div className="flex items-center gap-2 font-heading font-bold">
                        <Inbox className="h-5 w-5 text-primary" />
                        <span>Accountrix</span>
                        {currentTenant?.name && (
                            <span className="text-muted-foreground font-normal">· {currentTenant.name}</span>
                        )}
                    </div>
                    <div className="flex items-center gap-3">
                        <span className="text-sm text-muted-foreground hidden sm:inline">{user?.name || user?.email}</span>
                        <Button variant="ghost" size="sm" onClick={logout} data-testid="inbox-logout">
                            <LogOut className="h-4 w-4 mr-2" /> Log out
                        </Button>
                    </div>
                </div>
            </header>
            <main className="max-w-3xl mx-auto px-6 py-8">
                <Outlet />
            </main>
            <Toaster position="top-right" richColors />
        </div>
    );
};
